import { createAuthClient } from "better-auth/react";
import { deviceAuthorizationClient } from "better-auth/client/plugins";
import { getAuthApiURL } from "../util/select-api";

export const authClient = createAuthClient({
  baseURL: getAuthApiURL(),
  plugins: [deviceAuthorizationClient()],
});

export type Session = typeof authClient.$Infer.Session;

export const auth = authClient;
